
export interface SalesByHour {
  hour: number;
  sales: number;
  orders: number;
}

export interface SalesAnalytics {
  totalSales: number;
  totalOrders: number;
  averageOrderValue: number;
  peakHour?: number;
  salesByHour?: SalesByHour[];
  salesByDay?: { date: string; sales: number; orders: number }[];
}

export interface DrinkPopularity {
  drinkId: number;
  drinkName: string;
  totalOrders: number;
  totalQuantity: number;
  totalRevenue: number;
  averageRating?: number;
  lastOrderedAt?: string;
}

export interface StaffPerformance {
  staffId: number;
  staffName: string;
  ordersServed: number;
  totalSales: number;
  averageServiceTime: number;
  customerRating: number;
  date?: string;
}
